import React from 'react';
import { useTranslation } from 'react-i18next';
import { HomeIcon } from '@radix-ui/react-icons';
import { Select, TextInput } from '@/shared/ui';
import type { PropertyFilters } from './constants';
import { PAYMENT_FREQUENCY_OPTIONS } from './constants';
import { SectionHeader, FieldLabel } from './parts';
import { maskMoney } from './masks';

interface Props {
  filters: PropertyFilters;
  setFilters: (f: PropertyFilters) => void;
}

export const FilterSectionCondo: React.FC<Props> = ({ filters, setFilters }) => {
  const { t } = useTranslation('features/properties');

  const frequencyData = PAYMENT_FREQUENCY_OPTIONS.map((token) => ({
    value: token,
    label: t(`form.options.rentalPaymentFrequency.${token}`, { defaultValue: token }),
  }));

  return (
    <div>
      <SectionHeader icon={<HomeIcon width={14} height={14} />} title={t('filterPanel.condo')} />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-2)' }}>
        <div>
          <FieldLabel>{t('filterPanel.condoFeeMin')}</FieldLabel>
          <TextInput
            placeholder="R$ 0"
            value={filters.condoFeeMin || ''}
            onChange={(e) => setFilters({ ...filters, condoFeeMin: maskMoney(e.target.value) })}
          />
        </div>
        <div>
          <FieldLabel>{t('filterPanel.condoFeeMax')}</FieldLabel>
          <TextInput
            placeholder="R$ 5.000"
            value={filters.condoFeeMax || ''}
            onChange={(e) => setFilters({ ...filters, condoFeeMax: maskMoney(e.target.value) })}
          />
        </div>
      </div>
      <div style={{ marginTop: 'var(--space-2)' }}>
        <FieldLabel>{t('filterPanel.condoPaymentFrequency')}</FieldLabel>
        <Select
          data={frequencyData}
          value={filters.condoPaymentFrequency || null}
          onChange={(v: string | string[] | null) => setFilters({ ...filters, condoPaymentFrequency: Array.isArray(v) ? v[0] : (v ?? '') })}
          placeholder={t('filterPanel.selectFrequency')}
        />
      </div>
    </div>
  );
};
